import { motion } from "framer-motion";

const Details = () => {
  const sections = [
    {
      title: "OBJECTIF DE LA FORMATION",
      content:
        "Le Master en Intelligence Artificielle et Internet des Objets (IoT) vise à former des professionnels capables d'exploiter efficacement les données générées par les objets connectés dans divers domaines tels que la santé, l'industrie, la domotique, etc.",
    },
    {
      title: "CONDITIONS D'ADMISSION",
      items: [
        "Bac+3 et les titulaires de licences ou diplômes équivalents",
        "Les fonctionnaires des administrations et les employés du secteur privé",
        "L'accès est ouvert à tous les titulaires d'un Bac+2 (DTS, BTS, DUT, DEUG, DEUST, …) scientifique ou technique ou tout diplôme reconnu équivalent",
        "Les candidats munis du dossier d'inscription passent un entretien de sélection pour valider leur admission",
        "Prérequis : Mathématique de base et la physique",
      ],
    },
    {
      title: "PLATEFORME PÉDAGOGIQUE",
      subsections: [
        {
          title: "Semestre 1",
          items: [
            "Fondamentaux de l'IA",
            "Internet des Objets (IoT)",
            "Développement Web Front-End",
            "Fondamentaux du Big Data",
            "Bases de données et stockage de données Web",
            "Communication et présentation des données",
          ],
        },
        {
          title: "Semestre 2",
          items: [
            "Machine Learning",
            "Architecture et Conception de Systèmes IoT",
            "Stockage et gestion des données massives",
            "Cloud & Edge Computing",
            "Sécurité et confidentialité des données",
            "Intelligence Artificielle et Marketing",
          ],
        },
        {
          title: "Semestre 3",
          items: [
            "Deep Learning et applications",
            "Systèmes décisionnels et analytiques",
            "Développement Web Back-End",
            "Systèmes embarqués et applications Industrielles de l'IoT",
            "Traitement distribué et calcul massif",
            "Entrepreneuriat et Innovation Technologique",
          ],
        },
        {
          title: "Semestre 4",
          content:
            "Le projet de fin d'études est réalisé dans un milieu industriel – stage d'une durée de 4 à 6 mois dans le secteur industriel, de service ou de technologie.",
        },
      ],
    },
    {
      title: "DÉBOUCHÉS DE LA FORMATION",
      items: [
        "Ingénieur en IA et Développeur IoT",
        "Architecte de solutions IoT : Conception d'architectures et de systèmes IoT complexes",
        "Spécialiste en IA pour la santé et Ingénieur en biotechnologie IoT",
        "Ingénieur en systèmes autonomes et Gestionnaire de la chaîne d'approvisionnement IoT",
        "Urbaniste numérique et Ingénieur en bâtiment intelligent",
        "Analyste en données financières et Spécialiste en assurance IoT",
        "Ingénieur en fabrication intelligente et Chef de projet Industrie 4.0",
        "Ingénieur en réseaux IoT et Expert en sécurité des systèmes IoT",
      ],
    },
    {
      title: "DOSSIER D'INSCRIPTION",
      items: [
        "4 photos d'identité récentes identiques",
        "3 copies légalisées de CIN",
        "3 copies légalisées du Baccalauréat",
        "3 copies légalisées du BAC+2",
        "3 copies légalisées du BAC+3",
        "150 DH de frais de dossier non remboursable",
      ],
    },
  ];

  return (
    <div className="w-full min-h-screen bg-slate-50" id="details">
      <div className="max-w-6xl mx-auto px-4 py-12">
        {sections.map((section, index) => (
          <motion.section
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="bg-white rounded-xl border border-gray-100 shadow-lg mb-8 overflow-hidden"
          >
            <div className="bg-[#1e253f] px-8 py-5">
              <h2 className="text-lg font-bold text-white tracking-wide">
                {section.title}
              </h2>
            </div>

            <div className="p-8">
              {section.content && (
                <p className="text-slate-600 text-base leading-relaxed mb-8">
                  {section.content}
                </p>
              )}

              {section.items && (
                <ul className="space-y-4">
                  {section.items.map((item, idx) => (
                    <motion.li
                      key={idx}
                      initial={{ opacity: 0, x: -20 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.3, delay: idx * 0.1 }}
                      viewport={{ once: true }}
                      className="flex items-start space-x-4 text-slate-600"
                    >
                      <span className="text-[#1e253f] flex-shrink-0">
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                      </span>
                      <span className="text-base leading-relaxed">{item}</span>
                    </motion.li>
                  ))}
                </ul>
              )}

              {section.subsections && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8 mt-6 sm:mt-8">
                  {section.subsections.map((subsection, subIdx) => (
                    <motion.div
                      key={subIdx}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: subIdx * 0.1 }}
                      viewport={{ once: true }}
                      className="bg-gradient-to-br from-slate-50 to-white rounded-xl p-4 sm:p-6 border border-gray-100 shadow-md"
                    >
                      <div className="flex items-center space-x-3 sm:space-x-4 mb-3 sm:mb-4">
                        <span className="bg-[#1e253f] text-white px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg text-xs sm:text-sm font-bold">
                          S{subIdx + 1}
                        </span>
                        <h3 className="text-base sm:text-lg font-bold text-slate-900">
                          {subsection.title}
                        </h3>
                      </div>

                      {subsection.items ? (
                        <ul className="space-y-2 sm:space-y-3">
                          {subsection.items.map((item, itemIdx) => (
                            <li
                              key={itemIdx}
                              className="flex items-start space-x-2 sm:space-x-3 text-slate-600"
                            >
                              <span className="text-[#1e253f] mt-1.5">•</span>
                              <span className="text-sm sm:text-base leading-relaxed">
                                {item}
                              </span>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
                          {subsection.content}
                        </p>
                      )}
                    </motion.div>
                  ))}
                </div>
              )}
            </div>
          </motion.section>
        ))}

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="bg-[#1e253f] rounded-xl shadow-xl p-10 text-center mt-12"
        >
          <h2 className="text-white text-2xl font-bold mb-4">
            Prêt à commencer votre journey?
          </h2>
          <p className="text-indigo-100 text-lg mb-8">
            Développez vos compétences en IA et IoT
          </p>
          <button
            onClick={() =>
              document
                .getElementById("form")
                .scrollIntoView({ behavior: "smooth" })
            }
            className="inline-flex items-center px-8 py-4 bg-white text-[#1e253f] text-lg font-bold rounded-xl hover:bg-blue-50 transition-colors duration-300 shadow-md hover:shadow-lg"
          >
            Postuler Maintenant
            <svg
              className="w-6 h-6 ml-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default Details;
